import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyle = {
  position: 'absolute',
  left: (p) => p.spacing(-1.5),
  color: (p) => p.palette.primary[500],
};
